import config from "../../../../config";

export const hasOnlyKurvEquipment = (equipment) => {
  return (
    equipment?.length === 1 &&
    Number(equipment?.[0]?.id) ===
      config.paymentcloud.KURV_MERCHANT_EQUIPMENT_ID
  );
};

export const hasKurvEquipment = (equipment) => {
  return equipment?.some(
    (e) => Number(e?.id) === config.paymentcloud.KURV_MERCHANT_EQUIPMENT_ID,
  );
};

export const shouldConfirmOnlyKurvEquipment = ({
  equipments,
  processors,
  organizationId,
}) => {
  const showConfirmationDialog =
    processors?.includes(config.paymentcloud.KURV_PROCESSOR_ID) ||
    organizationId === config.paymentcloud.KURVPAY_ORG_ID;

  return hasOnlyKurvEquipment(equipments) && showConfirmationDialog;
};
